import { render, staticRenderFns } from "./PruritusSleepFormNode.vue?vue&type=template&id=31dafdd4&scoped=true&"
import script from "./PruritusSleepFormNode.vue?vue&type=script&lang=js&"
export * from "./PruritusSleepFormNode.vue?vue&type=script&lang=js&"
import style0 from "./PruritusSleepFormNode.vue?vue&type=style&index=0&id=31dafdd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dafdd4",
  null
  
)

export default component.exports